export default {
  ERROR_MESSAGE: {
    SERVER: (amount: number) =>
      `Desculpe, não foi possível enviar o${amount > 1 ? 's' : ''} documento${
        amount > 1 ? 's' : ''
      }. Verifique o formato dos arquivos ou entre em contato com o nosso atendimento pelo aplicativo.`,
    MAX_FILES:
      'Você só pode anexar no máximo 3 documentos. Tente novamente ou entre em contato com nosso atendimento pelo aplicativo.',
    MAX_SIZE:
      'Não foi possível anexar o arquivo pois o tamanho dele é maior que o permitido de 30MB, tente novamente ou entre em contato com nosso atendimento pelo aplicativo.',
  },
}
